import { TimeInput } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { TellescopeFormFieldBaseProps } from "../types";

export interface TimeFieldProps extends TellescopeFormFieldBaseProps<"Time"> {}

export const TimeField = ({ title, value, onChange, className, error, onBlur, touched }: TimeFieldProps) => {
  const showError = !!(error && touched);

  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <TimeInput
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={className}
        inputProps={{
          className: cn(showError && "border-destructive"),
          "aria-invalid": showError,
        }}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
